import React, { useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import LabelText from '../LabelText';

const TandC = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {form_component, lang} = props;
	const {fieldname, content, required, label, show_label} = form_component;
	const shouldShowLabelByFlag = (show_label === true || show_label === 1 || show_label === '1' || show_label === 'true');
	const shouldShowLabel = shouldShowLabelByFlag && Boolean((label || '').trim());

	const fv = useSelector(state => state.fv);
	useEffect(() => { // to be updated after render
		if (fv && required) {
			fv.addField(fieldname, {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	const handlePopupClick = useCallback((e) => {
		e.preventDefault();
		e.stopPropagation();
		const currentLang = lang || props.lang;
		const payload = {
			open: true,
			form_component: form_component,
			lang: currentLang
		};
		dispatch({type: 'SET_TANDC_MODAL_DATA', payload: payload});
	}, [form_component, lang, props.lang, dispatch]);

	// Handle clicks on the label:
	// - If 點到 .tandc-popup-link，攔截並開啟彈窗
	// - 其他情況讓瀏覽器原生 label 行為處理（可勾選 checkbox）
	const handleLabelClick = useCallback((e) => {
		const popupLink = e.target.closest('.tandc-popup-link');
		if (popupLink) {
			e.preventDefault();
			e.stopPropagation();
			handlePopupClick(e);
		}
	}, [handlePopupClick]);

	const processHtmlForInline = (html) => {
		if (!html) return '';
		return html
			.replace(/<p[^>]*>/gi, '<span style="display:inline;">')
			.replace(/<\/p>/gi, '</span>')
			.replace(/<div[^>]*>/gi, '<span style="display:inline;">')
			.replace(/<\/div>/gi, '</span>')
			.replace(/<br\s*\/?>/gi, ' ');
	}

	const renderContent = useMemo(() => {
		if (!content) return null;

		const popupRegex = /<tnc>(.*?)<\/tnc>/gi;
		const parts = [];
		let lastIndex = 0;
		let match;

		while ((match = popupRegex.exec(content)) !== null) {
			if (match.index > lastIndex) {
				const beforeText = content.substring(lastIndex, match.index);
				const processedBeforeText = processHtmlForInline(beforeText);
				parts.push(
					<span 
						key={`text-${lastIndex}`} 
						style={{
							display: 'inline'
						}} 
						dangerouslySetInnerHTML={{__html: processedBeforeText}} 
					/>
				);
			}

			const popupText = match[1];
			parts.push(
				<span
					key={`popup-${match.index}`}
					className="tandc-popup-link"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						handlePopupClick(e);
					}}
					style={{
						textDecoration: 'underline',
						cursor: 'pointer',
						color: 'inherit',
						display: 'inline',
						whiteSpace: 'nowrap'
					}}
				>
					{popupText}
				</span>
			);

			lastIndex = popupRegex.lastIndex;
		}

		if (lastIndex < content.length) {
			const remainingText = content.substring(lastIndex);
			const processedRemainingText = processHtmlForInline(remainingText);
			parts.push(
				<span 
					key={`text-${lastIndex}`} 
					style={{
						display: 'inline'
					}} 
					dangerouslySetInnerHTML={{__html: processedRemainingText}} 
				/>
			);
		}

		if (parts.length > 0) {
			return parts;
		}

		const processedContent = processHtmlForInline(content);
		return <span style={{display: 'inline'}} dangerouslySetInnerHTML={{__html: processedContent}} />;
	}, [content, handlePopupClick]);

	return (
		<div className="flex-grow-1 t-and-c form-group">
			{shouldShowLabel && (
				<LabelText
					form_component={form_component}
				/>
			)}
			<div className="form-check">
				<input
					type="checkbox"
					name={fieldname}
					id={fieldname}
					className="form-check-input"
				/>
				<label 
					htmlFor={fieldname}
					className="form-check-label xt_area"
					style={{
						cursor: 'pointer',
						display: 'inline'
					}}
					onClick={handleLabelClick}
				>
					{renderContent}
				</label>
			</div>
		</div>
	);
}

export default TandC;